const _excluded = ["scale", "pageIndex", "rotate", "children", "onLoadError", "onRenderError"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import React from 'react';
import { Page } from 'react-pdf';
import { ViewArchiveInfo } from "../../../status";
import { Spinner } from '@isyc-react/design/bootstrap';
import 'react-pdf/dist/esm/Page/TextLayer.css';

// TODO make scroll pagination with IntersectionObserver generic (use it in tiff too at least)

export const ViewPdfPageBase = /*#__PURE__*/React.memo( /*#__PURE__*/React.forwardRef((props, ref) => {
  const {
      scale,
      pageIndex,
      rotate,
      children,
      onLoadError,
      onRenderError
    } = props,
    rest = _objectWithoutProperties(props, _excluded);
  React.useEffect(() => {
    console.log('PAGE MOUNTED: ', pageIndex);
    return () => console.log('UNMOUNTED PAGE: ', pageIndex);
  }, [pageIndex]);
  return /*#__PURE__*/React.createElement(Page, _extends({
    pageIndex: pageIndex,
    scale: scale,
    rotate: rotate,
    canvasRef: ref,
    loading: /*#__PURE__*/React.createElement(ViewArchiveInfo, null, /*#__PURE__*/React.createElement("div", {
      className: "view-pdf-page-rendering-spinner"
    }, /*#__PURE__*/React.createElement(Spinner, {
      animation: "border",
      className: "text-primary"
    }))),
    renderAnnotationLayer: true,
    renderForms: false,
    onLoadError: e => {
      console.error('[PDF Viewer] Page load error: ', e);
      onLoadError && onLoadError(e);
    },
    onRenderError: e => {
      console.error('[PDF Viewer] Page render error: ', e);
      onRenderError && onRenderError(e);
    }
  }, rest), children);
}));